import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

const inBackend = document.body.classList.contains('neos-backend');


/**
 * Swiper
 */
document.querySelectorAll('.swiper').forEach((element) => {

    if (inBackend) return;

    const slides = element.querySelectorAll('.swiper-slide');
    if (slides.length < 2) {
        return;
    }

    new Swiper(element, {
        modules: [Navigation, Pagination],
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        // autoHeight: true,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            // The arrows are background images, see _swiper.scss
            addIcons: false,
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});
